import React from 'react';
import { Box, Typography, IconButton, Stack } from '@mui/material';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { IUserSummary } from '../../types/global/helper';
import { convertMinuteSecondsDays } from '../../utils/AppUtils';
import { ThspianAvatar } from '../Avatar/ThspianAvatar';

interface CommentBubbleProps {
    user: IUserSummary;
    comment: string;
    createdAt: string;
    totalLikes: number;
    isUserLiked?: boolean;
    onLike: () => void;
    onReply: () => void;
    canReply?: boolean;
}

export const CommentBubble: React.FC<CommentBubbleProps> = ({
    user,
    comment,
    createdAt,
    totalLikes,
    isUserLiked,
    onLike,
    onReply,
    canReply = true,
}) => {
    const { themeStyle } = useThemeContext();
    return (
        <Stack direction="row" alignItems="flex-start" spacing={1} sx={{ width: '100%' }}>
            <ThspianAvatar user={user} size="medium" />
            <Box flex={1} sx={{ background: theme[themeStyle].deep_grey, borderRadius: 2, p: 1, minWidth: 0 }}>
                <Typography variant="subtitle2" sx={{ color: theme[themeStyle].tag_white }}>
                    {user.userName}
                </Typography>
                <Typography variant="body2" sx={{ wordBreak: 'break-word', color: theme[themeStyle].tag_white }}>
                    {comment}
                </Typography>
                <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                    <IconButton size="small" onClick={onLike} color={isUserLiked ? 'primary' : 'default'}>
                        <ThumbUpAltOutlinedIcon
                            fontSize="small"
                            sx={{
                                color: isUserLiked ? theme[themeStyle].switchGreen : theme[themeStyle].tag_white,
                            }}
                        />
                    </IconButton>
                    <Typography variant="caption" sx={{ color: theme[themeStyle].tag_white }}>
                        {totalLikes}
                    </Typography>
                    {canReply && (
                        <IconButton size="small" onClick={onReply}>
                            <ReplyOutlinedIcon fontSize="small" sx={{ color: theme[themeStyle].tag_white }} />
                        </IconButton>
                    )}
                    <Typography variant="caption" sx={{ color: theme[themeStyle].tag_white }}>
                        {convertMinuteSecondsDays(createdAt)} ago
                    </Typography>
                </Stack>
            </Box>
        </Stack>
    );
};
